export enum PlusMinusButtonType {
  MINUS = 'minus',
  PLUS = 'plus',
}

export interface IPlusMinusButtonProps {
  onClick: () => void;
  disabled: boolean;
  isVisible: boolean;
  symbol: PlusMinusButtonType;
}
